var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.277,
    height: 33.785,
    viewBox: "0 0 26.277 33.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3580",
    "data-name": "Group 3580",
    transform: "translate(-35 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(35 26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M62.478,5.888H42.31L42.384.074,62.478,0Z",
    transform: "translate(-36.201)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M106.461,87.673H93.8l3.827-5.593h8.833Z",
    transform: "translate(-80.257 -70.229)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M56.74,169.1l-21.05.147,3.975-5.593H56.74Z",
    transform: "translate(-30.537 -140.022)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M15.457.51,6.035,17.44H0L6.182.51Z",
    transform: "translate(0 -0.436)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M15.457,81.06,0,103.141H0L6.182,81.06Z",
    transform: "translate(0 -69.357)",
    fill: "#ddd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.49a2e7d1a6a226b6ef9d3124d5f022c8.svg";
export { ForwardRef as ReactComponent };